const COMMENTS = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20warm%20smile%2C%20soft%20lighting%2C%20simple%20cream%20background%2C%20illustration%20portrait&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '追漫小能手',
    time: '2小时前',
    comic: '《剑尊归来》第87话',
    content: '这一话的打斗分镜太炸了！作者画工真的越来越强，主角觉醒那段我反复看了三遍，燃到头皮发麻。',
    likes: 2847,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20boy%20avatar%20with%20headphones%2C%20casual%20look%2C%20simple%20cream%20background%2C%20illustration%20portrait&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '深夜追更人',
    time: '5小时前',
    comic: '《我独自升级》第179话',
    content: '等了整整一周就为了这一话，程肖宇终于要面对最终BOSS了，剧情推进节奏完美，已经开始期待下周了。',
    likes: 1932,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20girl%20avatar%20with%20glasses%2C%20studious%20look%2C%20simple%20cream%20background%2C%20illustration%20portrait&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '漫画研究员',
    time: '8小时前',
    comic: '《樱花下的约定》大结局',
    content: '追了两年的漫画完结了，最后一话直接泪崩。感谢作者给我们带来这么美好的故事，强烈推荐给还没看的朋友。',
    likes: 5610,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20cool%20boy%20avatar%2C%20stylish%20hair%2C%20simple%20cream%20background%2C%20illustration%20portrait&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '热血番狂魔',
    time: '12小时前',
    comic: '《全职高手》第312话',
    content: '叶修这个战术鬼才又来了，团队赛的布局简直教科书级别。国漫能做到这个水准真的让人骄傲！',
    likes: 3204,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20gentle%20girl%20avatar%2C%20long%20hair%2C%20simple%20cream%20background%2C%20illustration%20portrait&width=120&height=120&seq=avatar-05&orientation=squarish',
    name: '甜饼收割机',
    time: '1天前',
    comic: '《暗黑法则》第56话',
    content: '这个反转我真的没想到！前面所有的伏笔在这一话全部回收了，作者简直就是布局天才，悬疑迷必入。',
    likes: 1890,
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            漫友热评
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            来自真实读者的追漫心声，看看大家都在追什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {COMMENTS.slice(0, 2).map((c, i) => (
            <div key={i} className="p-5 rounded-xl bg-background-50 border border-background-200/60">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-400">{c.time}</div>
                </div>
              </div>
              <div className="mb-2">
                <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
                  {c.comic}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{c.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{c.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
          {COMMENTS.slice(2).map((c, i) => (
            <div key={i + 2} className="p-5 rounded-xl bg-background-50 border border-background-200/60">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">{c.name}</div>
                  <div className="text-xs text-foreground-400">{c.time}</div>
                </div>
              </div>
              <div className="mb-2">
                <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">
                  {c.comic}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{c.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{c.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}